import { render } from "./InsightsSelector.vue?vue&type=template&id=4df98c24&lang=pug"
import script from "./InsightsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightsSelector.vue?vue&type=script&setup=true&lang=js"

import "./InsightsSelector.vue?vue&type=style&index=0&id=4df98c24&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__